export default function ReplyIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
    >
      <path
        d="M3.64645 9.14645C3.45118 9.34171 3.45118 9.65829 3.64645 9.85355L6.82843 13.0355C7.02369 13.2308 7.34027 13.2308 7.53553 13.0355C7.7308 12.8403 7.7308 12.5237 7.53553 12.3284L4.70711 9.5L7.53553 6.67157C7.7308 6.47631 7.7308 6.15973 7.53553 5.96447C7.34027 5.7692 7.02369 5.7692 6.82843 5.96447L3.64645 9.14645ZM19.5 17.5C19.5 17.7761 19.7239 18 20 18C20.2761 18 20.5 17.7761 20.5 17.5H19.5ZM4 10H17V9H4V10ZM19.5 12.5V17.5H20.5V12.5H19.5ZM17 10C18.3807 10 19.5 11.1193 19.5 12.5H20.5C20.5 10.567 18.933 9 17 9V10Z"
        fill="currentColor"
      />
    </svg>
  );
}
